'use client';

import { Tabs as V3Tabs, TabsProps, ButtonProps } from '@stadionhq-v3/base-ui';
import { THEMES } from '@stadionhq-v3/core';
import classnames from 'classnames';
import styles from './tabs.module.scss';

export type TabProps = Omit<ButtonProps, 'children' | 'url'> & {
  id: string;
  text: string;
  summary?: string;
  url?: string;
  selected?: boolean;
};

const Tabs = ({
  classNames = [],
  theme = THEMES.DEFAULT_1,
  ...props
}: TabsProps) => {
  const classes = classnames(
    [
      styles.tokens,
      styles.tabs,
      ...(theme ? [styles[theme.themeId], styles.themed] : [styles.neutral]),
      ...(props.onDark ? [styles.onDark, styles.neutral] : []),
      ...(props.rounded ? [styles.rounded] : [styles.square]),
      ...(props.grouped ? [styles.grouped] : [styles.ungrouped]),
      ...(props.outlined ? [styles.outlined] : [styles.nonOutlined]),
    ],
    classNames
  );

  return <V3Tabs classNames={[classes]} theme={theme} {...props} />;
};

export default Tabs;
